import React, { useEffect, useRef, useState } from "react";
import { withRouter } from "../../../App";
import { connect } from "react-redux";
import { getLoggenInToken } from "../../../store/selectors/AuthSelectors";
import { Button, Modal } from "react-bootstrap";
import Candidates from "./Candidates";
import { get } from "../../../services/api";
import { toast } from "react-toastify";

const AssignCandidate = ({
  showAssignCandidateModal,
  setShowAssignCandidateModal,
  selectedRequirement,
  token,
  weekRange,
}) => {
  const [restrictedCandidates, setRestrictedCandidates] = useState([]);

  useEffect(() => {
    fetchRestrictedCandidates();
  }, []);
  const fetchRestrictedCandidates = async () => {
    if (selectedRequirement?.companyId) {
      try {
        const response = await get(
          `/api/restrict-candidate/company/${selectedRequirement?.companyId}`,
          token
        );
        setRestrictedCandidates(response);
      } catch (error) {
        console.error("Error fetching restricted candidates:", error);
        toast.error("Failed to load restricted candidates.");
      }
    }
  };
  console.log("selectedRequirement", selectedRequirement);
  return (
    <Modal
      className="fade bd-example-modal-lg"
      show={showAssignCandidateModal}
      size="lg"
      onHide={() => setShowAssignCandidateModal(false)}
    >
      <Modal.Header>
        <Modal.Title>
          Assign Candidates {selectedRequirement?.jobTitle} (
          {selectedRequirement?.jobID})
        </Modal.Title>
        <Button
          variant=""
          className="btn-close"
          onClick={() => setShowAssignCandidateModal(false)}
        ></Button>
      </Modal.Header>
      <Modal.Body>
        <Candidates
          selectedRequirement={selectedRequirement}
          setShowAssignCandidateModal={setShowAssignCandidateModal}
          restrictedCandidates={restrictedCandidates}
          weekRange={weekRange}
        />
      </Modal.Body>
    </Modal>
  );
};

const mapStateToProps = (state) => {
  return {
    token: getLoggenInToken(state),
  };
};

export default withRouter(connect(mapStateToProps)(AssignCandidate));
